import { BUSCAR_PESSOA_CONTRATANTE, SELECIONAR_PESSOA_CONTRATANTE } from '../../actions/types'

const initialState = undefined

export default function reducerPessoaContratante (state = {}, action = initialState) {
  switch (action.type) {
    case BUSCAR_PESSOA_CONTRATANTE: {
      return action.payload.data;
    }

    case SELECIONAR_PESSOA_CONTRATANTE: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
